import { render, staticRenderFns } from "./AcessoRapido.vue?vue&type=template&id=6d1c22b6&scoped=true&lang=pug"
import script from "./AcessoRapido.vue?vue&type=script&lang=js"
export * from "./AcessoRapido.vue?vue&type=script&lang=js"
import style0 from "./AcessoRapido.vue?vue&type=style&index=0&id=6d1c22b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1c22b6",
  null
  
)

export default component.exports